import { c as _c } from "react/compiler-runtime";
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { RatesAndFeesLink } from 'src/features/product-card/RatesAndFeesLink';
export default function ReviewProductCardRatesAndFeesButton() {
  const $ = _c(8);
  const {
    marketplaceEntity: t0
  } = useReviewContext();
  const {
    ctaAnalytics,
    termsAndFeesLink,
    versionId,
    name,
    displayName
  } = t0;
  let t1;
  if ($[0] !== ctaAnalytics || $[1] !== displayName || $[2] !== name || $[3] !== termsAndFeesLink || $[4] !== versionId) {
    t1 = termsAndFeesLink && <RatesAndFeesLink analytics={{
      ...ctaAnalytics,
      section: {
        ...ctaAnalytics.section,
        name: "review_product_card"
      },
      linkType: "RATES_AND_FEES_TEXT"
    }} href={termsAndFeesLink} versionId={versionId} additionalParams={{
      monetizable: ctaAnalytics.monetizable
    }} showBlankTargetIcon={true} name={displayName || name} />;
    $[0] = ctaAnalytics;
    $[1] = displayName;
    $[2] = name;
    $[3] = termsAndFeesLink;
    $[4] = versionId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <>{t1}</>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}